<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ProjProgressForm',
})
</script>
<template>
  <Spin :spinning="submitLoading">
    <Form ref="formRef" :model="model" layout="vertical" scrollToFirstError>
      <FormItem v-for="item in steps" :label="item.label" :name="item.value">
        <ProjProcessStatusRadio :value="model[item.value]" @update:value="val => setProcess(val, item.value)" />
      </FormItem>
    </Form>
  </Spin>
</template>

<script lang="ts" setup name="ProjProgressForm">
import { Form, message, Spin } from 'ant-design-vue'
import { ref, watch } from 'vue'
import { ProjProcessStatusRadio } from '-/Business'
import { FormItem } from '-/Common/Form'
import { handleFormError } from '@/hooks/useForm'
import { useDetailLy } from '@/hooks/useDetailLy'
const formRef = ref()
const { id, result, refresh } = useDetailLy()
const props = withDefaults(
  defineProps<{
    steps?: BaseOption<string>[]
    api: BD.PromiseFn<any>
  }>(),
  {
    steps: () => []
  }
)
const model = ref<Record<string, number>>({})
const setModel = () => {
  const _model = props.steps.reduce((acc, curr) => {
    acc[curr.value] = result.value?.[curr.value]
    return acc
  }, {} as any)
  model.value = _model
}
watch(result, setModel, { immediate: true })
const submitLoading = ref(false)
const setProcess = async (val: number, key: string) => {
  submitLoading.value = true
  try {
    await props.api({
      id: id.value,
      [key]: val
    })
    message.success('保存成功')
    refresh()
  } catch (err) {
    handleFormError(err)
  }
  submitLoading.value = false
}
</script>
